import { render, staticRenderFns } from "./ColumnWithMarkers.vue?vue&type=template&id=31197961&"
import script from "./ColumnWithMarkers.vue?vue&type=script&lang=js&"
export * from "./ColumnWithMarkers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports